import React from 'react'
import { connect } from 'react-redux'
import Loading from 'components/Loading'

function ContentLoader(props) {
  const {
    isLoadFormList,
    isLoadLocusGroupList,
    isLoadLocusList,
    isLoadEventList,
    isLoadFormEventValues,
    isLoadLocusGroupEventValues,
    isLoadLocusEventValues,
  } = props

  const isShowLoader =
    isLoadFormList ||
    isLoadLocusGroupList ||
    isLoadLocusList ||
    isLoadEventList ||
    isLoadFormEventValues ||
    isLoadLocusGroupEventValues ||
    isLoadLocusEventValues

  return !isShowLoader ? null : <Loading pastDelay />
}

export default connect(state => ({
  isLoadFormList: state.getIn(['logbookForm', 'isLoadFormList']),
  isLoadLocusGroupList: state.getIn(['logbookForm', 'isLoadLocusGroupList']),
  isLoadLocusList: state.getIn(['logbookForm', 'isLoadLocusList']),
  isLoadEventList: state.getIn(['logbookForm', 'isLoadEventList']),
  isLoadFormEventValues: state.getIn(['logbookForm', 'isLoadFormEventValues']),
  isLoadLocusGroupEventValues: state.getIn([
    'logbookForm',
    'isLoadLocusGroupEventValues',
  ]),
  isLoadLocusEventValues: state.getIn([
    'logbookForm',
    'isLoadLocusEventValues',
  ]),
}))(ContentLoader)
